export default {
  title: "鄠邑气象微信公众服务平台",
  defaultStationObj: {
    areaCode: "610100",
    adminCode: "610118",
    stationName: "鄠邑区",
    lon: 108.55596,
    lat: 33.956506,
    station_id_c: "57132",
  },
  // staIds: 'V8255,V8256,V8221,V8222,V8231,V8232,V8233,V8234,V8235,V8236,V8253,V8282,V8286,V8240,V8281,V8283,V8252,V8287,57132',
  staIds:
    "57132,V0004,V8201,V8202,V8203,V8221,V8222,V8231,V8232,V8233,V8234,V8235,V8236,V8240,V8251,V8252,V8253,V8254,V8255,V8256,V8261,V8281,V8282,V8283,V8286,V8287,V8284,V8285,V8291,V8293,V8294,V8297,V8298,V8271,V8274,V8241,V8242,V8278,V8250",
  imgUrl: `http://snwechat.sxktqx.com/files`,
  baseUrl: "http://124.70.8.80:8721",
  fileUrl: "http://113.200.138.96:8752/docs_static",
};
